//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SIdentify from '@/components/SIdentify.vue'
import Cookies from '@/plugin/cookies.js'
export default {
  data() {
    // const validateVerifycode = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('请输入验证码'))
    //   } else if (value !== this.identifyCode) {
    //     console.log('validateVerifycode:', value)
    //     callback(new Error('验证码不正确!'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      logining: false,
      isVerifyCode: 0,
      loginForm: {
        username: '',
        password: '',
        verifycode: ''
      },
      loginRule: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        verifycode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
        // verifycode: [
        //   { required: true, trigger: 'blur', validator: validateVerifycode }
        // ]
      },
      checked: false,
      identifyCodes: '1234567890',
      identifyCode: '',
      selectVisible: false,
      pwdType: 'password',
      eyeType: 'el-input__icon el-icon-view',
      imgSrc: this.$api.validateCode
    }
  },
  components: {
    SIdentify
  },
  created() {
    // 在页面加载时从cookie获取登录信息
    let username = Cookies.getCookie('aun')
    let password = Cookies.getCookie('aupwds')
    // 如果存在赋值给表单，并且将记住密码勾选
    if (username) {
      this.checked = true
      this.loginForm.username = username
      this.loginForm.password = password
    }
  },
  methods: {
    toregist() {
      this.$router.push({ path: '/regist' })
    },
    handleSubmit(event) {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.logining = true
          let params = {
            UserName: this.loginForm.username.trim(),
            Password: this.loginForm.password.trim(),
            VerifyCode: this.loginForm.verifycode.trim()
          }
          this.$api
            .adminLogin(params)
            .then(res => {
              if (res.Status === 1) {
                this.logining = false
                this.isVerifyCode = 0
                sessionStorage.setItem('token', res.Entity)
                sessionStorage.setItem(
                  'adminuser',
                  this.loginForm.username.trim()
                )
                if (this.checked) {
                  Cookies.setCookie('aun', this.loginForm.username.trim(), 10)
                  Cookies.setCookie(
                    'aupwds',
                    this.loginForm.password.trim(),
                    10
                  )
                } else {
                  Cookies.setCookie('aun', '')
                  Cookies.setCookie('aupwds', '')
                }
                this.selectVisible = true
              } else {
                this.isVerifyCode++
                this.logining = false
                this.refreshCode()
                this.$alert(res.Message, '错误', {
                  confirmButtonText: '确定'
                })
              }
            })
            .catch(function(res) {
              this.$alert('无法登录', '错误', {
                confirmButtonText: '确定'
              })
              this.logining = false
              this.refreshCode()
            })
        } else {
          this.$alert('无法登录', '错误', {
            confirmButtonText: '确定'
          })
          this.logining = false
          this.refreshCode()
          return false
        }
      })
    },
    toAdmin() {
      this.$router.push({ path: '/admin/' })
    },
    toAdminRepair() {
      this.$router.push({ path: '/admin/repair/' })
    },
    showPassword(event) {
      if (this.pwdType === 'password') {
        this.pwdType = 'text'
        this.eyeType = 'el-input__icon el-icon-loading'
      } else {
        this.pwdType = 'password'
        this.eyeType = 'el-input__icon el-icon-view'
      }
    },
    // 生成随机数
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    // 切换验证码
    refreshCode() {
      // this.identifyCode = ''
      // this.makeCode(this.identifyCodes, 4)
      let src = this.imgSrc
      this.imgSrc = ''
      this.$nextTick(() => {
        this.imgSrc = src + '?'
      })
    }
    // // 生成四位随机验证码
    // makeCode(o, l) {
    //   for (let i = 0; i < l; i++) {
    //     this.identifyCode += this.identifyCodes[
    //       this.randomNum(0, this.identifyCodes.length)
    //     ]
    //   }
    //   console.log(this.identifyCode)
    // }
  }
}



// WEBPACK FOOTER //
// ./src/admin/Login.vue